import { render, staticRenderFns } from "./AudioStickerParticipantCard.vue?vue&type=template&id=2df4545b&"
import script from "./AudioStickerParticipantCard.vue?vue&type=script&lang=js&"
export * from "./AudioStickerParticipantCard.vue?vue&type=script&lang=js&"
import style0 from "./AudioStickerParticipantCard.vue?vue&type=style&index=0&id=2df4545b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports